export const ALPHA_WHITELIST = [
  'admin@etherbuildr.com',
  'r@snow87.com',
  'thomas.a.k.tk@gmail.com',
  'afrehner66@gmail.com',
  'coralabish@gmail.com',
  'chris.grieb@gmail.com',
  'johnbridge@gmail.com'
]
